import { Api } from 'models/services/api';
import { CreatePosSystemQuery } from 'models/services/graphql';

import { PosSystemData, PosSystemDataToSave } from '../index';

type DataToCreate = {
  input: PosSystemDataToSave;
};

const RequestQuery = `
  mutation CreatePosSystem($input: PosSystemInput!) {
    ${CreatePosSystemQuery}
  }
`;

type ResponseData = {
  data: {
    createPosSystem: PosSystemData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: PosSystemData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createPosSystem;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };